module.exports = __webpack_public_path__ + "img/lunch_title--success.a470fb61.png";